export default function(controller, target) {
  target.classList.toggle("dropdown-search-list-item-selected");
  const previouslySelected = controller.selectedOption;
  if (previouslySelected) {
    previouslySelected.classList.toggle("dropdown-search-list-item-selected");
    previouslySelected.removeAttribute("aria-selected");
    previouslySelected.classList.remove(...controller.selectedClassesOrDefault);
  }

  target.setAttribute("aria-selected", "true");
  target.classList.add(...controller.selectedClassesOrDefault);
  controller.inputTarget.setAttribute("aria-activedescendant", target.id);
  target.scrollIntoView({ behavior: "smooth", block: "nearest" });
}
